<template>
    <div class="app-header-menu app-header-mobile-drawer align-items-stretch">
        <!--begin::Menu-->
        <div class="title-site">
            <h2 class="name">{{pageTitle}}</h2>
        </div>
        <!--end::Menu-->
    </div>
</template>

<script lang="ts">
    import { defineComponent } from "vue";
    import { useRoute } from "vue-router";
    import MainMenuConfig from "@/layouts/default-layout/config/MainMenuConfig";
    export default defineComponent({
        name: "KTMenu",
        components: {},
        setup() {
            const route = useRoute();
            const pageTitle = ref("");

            const search = (menuItems) => {
                for (const item of menuItems) {
                    // Kiểm tra nếu route khớp thì gán heading
                    if (item.route === route.path) {
                        pageTitle.value = item.heading || item.sectionTitle;
                    }

                    if (item.sub) {
                        search(item.sub);
                    } else if (item.pages) {
                        search(item.pages);
                    }
                }
            }

            search(MainMenuConfig);

            watch(
                () => route.path,
                () => {
                    search(MainMenuConfig);
                })

            return {
                pageTitle
            };
        },
    });
</script>